import React, { useState, useEffect } from "react";
import {
  addDoc,
  collection,
  getFirestore,
  getDocs,
  doc,
  updateDoc,
} from "firebase/firestore";
import Menu from "../Menu/Menu";
import LoaderAdmin from "../LoaderAdmin";
import { useUsersContext } from "../../Context/UsersContext";
import { useDBContext } from "../../Context/DBcontext";
import InputWlabel from "../Inputs/InputWlabel";
import { useAdminContext } from "../../Context/AdminContext";
import GalleryModal from "../NewArticle/GalleryModal";
export default function BannersEdit() {
  const db = getFirestore();
  const { loggedData } = useUsersContext();
  const { banners, getBanners } = useDBContext();
  const {
    uploadedShop,
    uploadedZip,
    uploadingZip,
    bigImg,
    alreadyExists,
    handleUploadShopImage,
    handleChange,
  } = useAdminContext();

  const [section, setSection] = useState(null);
  const [openGallery, setOpenGallery] = useState(false);
  const [newButton, setNewButton] = useState("");
  const [newEdition, setNewEdition] = useState("");
  const [newImg, setNewImg] = useState("");
  const [newHashtag, setNewHashtag] = useState("");
  const [newNumber, setNewNumber] = useState("");
  let magazineBanner = banners ? banners.find((e) => e.id === "launch") : null;

  const openGalleryF = () => {
    setOpenGallery(!openGallery);
  };


  useEffect(() => {
    getBanners();

  }, []);

  useEffect(() => {
    if(magazineBanner) {
        setNewButton(magazineBanner.button)
        setNewEdition(magazineBanner.edition)
        setNewImg(magazineBanner.img)
        setNewHashtag(magazineBanner.hashtag)
        setNewNumber(magazineBanner.number)
    }
  }, [magazineBanner])
  


  
  const chooseMagazine = (e) => {
    setNewImg(e);
    openGalleryF()
  };



  let newMagazineBanner = {
    button: newButton,
    edition: newEdition,
    img: newImg,
    hashtag: newHashtag,
    number: newNumber,
  };

  const save = async (newArticle) => {
    try {
      const articleRef = doc(db, "banners", "launch");

      await updateDoc(articleRef, newArticle);
    } catch (error) {
      console.error("Ocurrió un error durante la actualización:", error);
    }
  };

  const [chosingCover, setChosingCover] = useState(false);

  return (
    <div className="admin-section-cont">
      {loggedData ? (
        <>
          <Menu />
          <div className="w85 position-relative">
          {openGallery ? (
        <GalleryModal
    
        //   handleInsert={handleInsert}
          openGallery={openGallery}
          openGalleryF={openGalleryF}
          uploadedShop={uploadedShop}
          alreadyExists={alreadyExists}
          uploadedZip={uploadedZip}
          uploadingZip={uploadingZip}
          handleChange={handleChange}
          handleUploadShopImage={handleUploadShopImage}
          magazine={true}
          chooseMagazine={chooseMagazine}


        //   insertImageF={insertImageF}
        />
      ) : (
        <></>
      )}
            {/* {banners.map((e, index) => 
            <button onClick={() => {
                setSection(e.id)
            }} key={index} className="buttonbyn"> {e.id === "launch" ? "Lanzamiento" : e.id } </button>          
        )} */}
            <div className="column gap1rem w300px">



                <p className="title"> BANNER LANZAMIENTO </p>
              <InputWlabel
                att="button"
                type="text"
                label="Texto del botón"
                column={true}
                value={newButton}
                edit={true}
                onchange={(e) => setNewButton(e.target.value)}
              />

              <InputWlabel
                att="edition"
                type="text"
                label="Edición"
                column={true}
                value={newEdition}
                edit={true}
                onchange={(e) => setNewEdition(e.target.value)}
              />

              <InputWlabel
                att="hashtag"
                type="text"
                label="Hashtag"
                column={true}
                value={newHashtag}
                edit={true}
                onchange={(e) => setNewHashtag(e.target.value)}
              />

              <InputWlabel
                att="number"
                type="text"
                label="Número de edición"
                column={true}
                value={newNumber}
                edit={true}
                onchange={(e) => setNewNumber(e.target.value)}
              />

              <img className="img" src={newImg} alt="" />

              <button     className="buttonbyn" onClick={openGalleryF}>Modificar imagen</button>

              <button
                className="buttonbyn"
                onClick={() => {
                  save(newMagazineBanner);
                }}
              >
                Guardar cambios
              </button>
            </div>
          </div>
        </>
      ) : (
        <LoaderAdmin loggedData={loggedData} />
      )}
    </div>
  );
}
